package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Craving_observation(
  public val id: String,
  public val habit: String,
  public val date: String,
  public val sensations: String,
  public val zones: String,
  public val intensity: Long,
  public val outcome: String,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
